"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ImageFile = function ImageFile(_ref) {
  var resource = _ref.resource;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].imageModalContent
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: resource.url,
    alt: resource.draft_label
  }));
};
ImageFile.propTypes = {
  resource: _propTypes["default"].object
};
var _default = ImageFile;
exports["default"] = _default;